import { createFileRoute, redirect } from "@tanstack/react-router";

// ID-only tool — 308 single-hop redirect to canonical ID URL.
export const Route = createFileRoute("/en/tools/weton-check")({
  loader: () => {
    throw redirect({ to: "/tools/cek-weton", code: 308 } as any);
  },
  component: () => null,
});